/* eslint-disable react/no-unescaped-entities */
import Typography from '@mui/material/Typography';
import { colors } from '@startengine/design-system.theme.main';

import { homeMenu } from 'utils/links';

const whatIsAnAccreditedInvestor = {
  id: 'whatDoesExclusiveMean',
  title: 'What does “Exclusive for Accredited Investors” mean?',
  detail: (
    <>
      <Typography variant="p1" color="success" component="span">
        Unlike Regulation Crowdfunding and Regulation A+ offerings, which are open to the general
        public, Regulation D (Reg. D) offerings are only available to Accredited Investors and
        Qualified Purchasers. Prior to investing in a Reg. D offering,{' '}
      </Typography>
      <Typography variant="p1" color="success" fontWeight={700} component="span">
        you’ll need to provide documentation proving your accreditation or qualified status, such as
        a W-2, account statement, or FINRA CRD number.
      </Typography>
      <br />
      <br />
      <ul
        style={{
          marginTop: 0,
        }}
      >
        <li>
          <Typography variant="p1" color="success">
            An accredited investor has earned income that exceeded $200,000 (or $300,000 with a
            spouse) in each of the prior two years, and reasonably expects the same for the current
            year; or a net worth of over $1 million, excluding the investor's primary residence; or
            a Series 7, 65, or 82 license.
          </Typography>
        </li>
        <li>
          <Typography variant="p1" color="success">
            A qualified purchaser has an investment portfolio with a liquid value of $5 million or
            more.
          </Typography>
        </li>
      </ul>
    </>
  ),
};

export const whatIsAQualifiedPurchaser = {
  id: 'whatIsAQualifiedPurchaser',
  title: 'What is a qualified purchaser?',
  detail: (
    <Typography variant="p1" color="success">
      In the U.S., a "qualified purchaser" must meet a higher financial qualification than
      "accredited investor."
      <br />
      <br />
      Individuals and certain entities may qualify as qualified purchasers. In order to be
      considered a qualified purchaser, you are required to have:
      <ul>
        <li>
          <b>$5+ million in investments</b> for an individual, family business, or estate planning
          entity (e.g., certain trusts) excluding primary residences and business property.
        </li>
        <li>
          <b>$25+ million in investments</b> for an investment manager
        </li>
      </ul>
      <br />
      Investments can include:
      <ul>
        <li>Stocks</li>
        <li>Bonds</li>
        <li>Mutual funds</li>
        <li>Cash or cash equivalents</li>
        <li>Real estate (excluding primary residence or business property)</li>
      </ul>
      <br />
      For more information, you can visit{' '}
      <a
        href="https://carta.com/learn/private-funds/regulations/qualified-purchaser/"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          textDecoration: 'underline',
          color: '#185C65',
          fontWeight: 700,
        }}
      >
        here
      </a>{' '}
      and contact your financial advisor.
    </Typography>
  ),
};

export const sePrivateList = [
  {
    id: 'howMuchCanIInvest',
    title: 'How much can I invest?',
    detail: (
      <Typography variant="p1" color="success">
        There are no restrictions for accredited investors.
      </Typography>
    ),
  },
  {
    id: 'whenIInvest',
    title: 'When I invest, what am I purchasing?',
    detail: (
      <Typography variant="p1" color="success">
        When you invest, you are purchasing an interest in a Series LLC, which owns shares of the
        underlying company either directly or indirectly. You will not be purchasing shares in the
        underlying company itself.
      </Typography>
    ),
  },
  {
    id: 'howToOpenIRA',
    title: 'How to open a Self-Directed IRA on StartEngine?',
    detail: (
      <Typography variant="p1" color="success">
        StartEngine makes it easy to invest using your retirement funds. You can open a
        self-directed IRA account through StartEngine. To get started, simply visit{' '}
        <a
          href="https://startengine.com/ira-account"
          style={{
            textDecoration: 'none',
            fontWeight: 700,
            color: colors.SEDark,
          }}
        >
          our IRA page
        </a>{' '}
        for more information and step-by-step instructions.
        <br />
        <br />
        Already have a self-directed IRA with another provider? You can still invest on StartEngine,
        but please note that the process will be manual and may take longer to complete.
      </Typography>
    ),
  },
  {
    id: 'whatsASeriesLLC',
    title: 'What’s a Series Limited Liability Company or Series LLC?',
    detail: (
      <Typography variant="p1" color="success">
        A Series LLC, like StartEngine Private, is a parent LLC that includes multiple series, each
        of which holds interests in different underlying companies. The series either directly or
        indirectly invests in and holds shares of the underlying company. Each series will merely be
        a separate series and not a separate legal entity. Under Delaware law, if certain conditions
        are met, the liability of investors holding one series of interests is segregated from the
        liability of investors holding another series of interests, and the assets of one series of
        interests are not available to satisfy the liabilities of other series of interests. In the
        case of StartEngine Private, each series will be created for the purpose of holding an
        equity interest in stated underlying companies.
      </Typography>
    ),
  },
  {
    id: 'whenWillIReceiveMembershipInterest',
    title: 'When will I receive my membership interest?',
    detail: (
      <Typography variant="p1" color="success">
        After the close of an offering, all investors whose funds have “cleared” by this time will
        be included in the disbursement. At this time, each investor will receive an email from
        StartEngine with their Countersigned Subscription Agreement, which will serve as their proof
        of purchase moving forward. Please keep in mind that a company can conduct a series of
        “closes” or withdrawals of funds throughout the duration of the campaign. If you are
        included in that withdrawal period, you will be emailed your countersigned subscription
        agreement and proof of purchase immediately following that withdrawal.
      </Typography>
    ),
  },
  {
    id: 'howDoYouDetermine',
    title: 'How do you determine the share price?',
    detail: (
      <Typography variant="p1" color="success">
        The series of StartEngine Private Funds purchases the underlying securities from an
        affiliate. The affiliate previously sourced and negotiated the terms to purchase these
        underlying securities from third parties. The amount paid by the series of the StartEngine
        Private Funds is higher than the price the affiliate purchased the securities previously in
        the secondary market. We also note that while StartEngine Advisers LLC does not impose any
        continuing management fee expenses, there may be a carried interest associated with the
        investment in our series, and therefore to the extent the securities appreciate in value
        there will not be a one-to-one economic parity between the share value of the StartEngine
        Private shares and the underlying companies&apos; shares. Please read the &quot;Risk
        Factors,&quot; which is included as Exhibit B to the subscription agreement for further
        details.
      </Typography>
    ),
  },
  {
    id: 'whatWillTheReturnOnMyInvestmentBe',
    title: 'What will the return on my investment be?',
    detail: (
      <Typography variant="p1" color="success">
        In the event that an underlying company experiences a liquidity event, after the relevant
        holding period is over, either the proceeds from the sale of the shares will be distributed
        to investors, or if requested, the shares will be transferred to the investor’s brokerage
        account of choice, minus any applicable fund operating expenses or carried interest. Holding
        period length varies from company to company. Please note that we are not permitted to
        provide financial advice. You may want to contact a financial professional to discuss
        possible investment outcomes.
      </Typography>
    ),
  },
  {
    id: 'canICancelMyInvestment',
    title: 'Can I cancel my investment?',
    detail: (
      <Typography variant="p1" color="success">
        Investors are able to cancel their investment for 48 hours after submitting their
        investment. Once your investment is canceled, there is a 10-day clearing period (from the
        date your investment was submitted). After your funds have cleared the bank, you will
        receive your refund within 10 business days. Refunds that are made through ACH payments can
        take up to 10 business days to clear. Unfortunately, we are at the mercy of the bank, but we
        will do everything we can to get you your refund as soon as possible. However, every
        investment needs to go through the clearing process in order to be sent back to the account
        associated with the investment.
      </Typography>
    ),
  },
  {
    id: 'whatIsTheDifferenceBetweenRegulations',
    title:
      'What is the difference between Regulation D 506(c), Regulation Crowdfunding, and Regulation A+?',
    detail: (
      <Typography variant="p1" color="success">
        Regulation D 506(c) allows companies to raise an unlimited amount of capital from accredited
        investors through general solicitation and advertising, provided that all purchasers are
        verified as accredited investors. Both Title III (Regulation Crowdfunding) and Title IV (Reg
        A+) help entrepreneurs crowdfund capital investments from unaccredited and accredited
        investors. The differences between these regulations are related to the investor
        limitations, the differing amounts of money companies are permitted to raise, and differing
        disclosure and filing requirements. To learn more about Regulation Crowdfunding,{' '}
        <a href={homeMenu.regulationCrowdfunding} target="_blank" rel="noopener noreferrer">
          read our Regulation Crowdfunding guide
        </a>
        , and for Regulation A+,{' '}
        <a href={homeMenu.regulationA} target="_blank" rel="noopener noreferrer">
          read our Regulation A+ guide
        </a>
        .
      </Typography>
    ),
  },
  {
    id: 'whatIsAnAccreditedInvestor',
    title: 'What is an accredited investor?',
    detail: (
      <Typography variant="p1" color="success">
        In the US, an accredited investor includes anyone who:
        <ul>
          <li>
            earned income that exceeded <b>$200,000</b> (or <b>$300,000</b> together with a spouse
            or spousal equivalent) in each of the prior two years and reasonably expects the same
            for the current year, or;
          </li>
          <li>
            has a net worth over <b>$1 million</b>, either alone or together with a spouse or
            spousal equivalent (excluding the value of the person’s primary residence), or;
          </li>
          <li>
            holds in good standing a Series <b>7</b>, <b>65</b>, or <b>82</b> license.
          </li>
        </ul>
        For more information, you can visit{' '}
        <a
          href="https://www.sec.gov/fast-answers/answers-accredhtm.html"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: 'underline',
            color: '#185C65',
            fontWeight: 700,
          }}
        >
          here
        </a>{' '}
        and contact your financial advisor.
      </Typography>
    ),
  },
  {
    id: 'whatDoIHaveToProvide',
    title: 'What do I have to provide to verify my status as an accredited investor?',
    detail: (
      <Typography variant="p1" color="success">
        Please note: you can also have a Licensed Attorney, Licensed Accountant, Registered
        Broker-Dealer, or Registered Investment Advisor provide{' '}
        <b>a letter affirming your accreditation.</b>
        <br />
        <br />
        Alternatively, the following information will be required:
        <br />
        <ul>
          <li>
            <b>To verify your income:</b> provide the last 2 years’ worth of tax documents that
            prove you have had sufficient income for the last two years to meet requirements.
          </li>
          <li>
            <b>To verify your net worth:</b> provide account statements, proof of property
            ownership, or other documentation showing ownership that proves you have a net worth
            that meets requirements.
          </li>
          <li>
            <b>To verify your Series 7, 65, or 82 license:</b> provide your FINRA CRD number for
            validation.
          </li>
        </ul>
      </Typography>
    ),
  },
];

export const faqTTWListAccred = [
  {
    id: 'meanToMakeAReservation',
    title: 'What does it mean when I make a reservation?',
    detail: (
      <Typography variant="p1" color="success">
        When you make a reservation, you’re simply indicating interest in an upcoming offering – not
        actually investing. This is non-binding and no money changes hands. Later, when the offering
        launches, we’ll let you know, and you can decide whether you want to follow through with
        your investment at that point.
      </Typography>
    ),
  },
  {
    id: 'howToBeNotified',
    title: 'Once the offering launches, how will I be notified?',
    detail: (
      <Typography variant="p1" color="success">
        We’ll notify everyone who made a reservation – at which point, you can confirm whether you’d
        like to complete your investment or not.
      </Typography>
    ),
  },
  {
    id: 'willIBeCharged',
    title: 'Will I be charged?',
    detail: (
      <Typography variant="p1" color="success">
        No. At this stage, you’re simply indicating that you would be interested in an upcoming
        offering. After the offering launches, you’ll have a chance to confirm whether you’d like to
        complete your investment or not.
      </Typography>
    ),
  },
  {
    id: 'canICancel',
    title: 'Can I cancel my reservation?',
    detail: (
      <Typography variant="p1" color="success">
        Yes. At this stage, you’re simply indicating interest in an upcoming offering. This is
        non-binding, and you can choose to cancel at any time before making an actual investment.
      </Typography>
    ),
  },
  whatIsAnAccreditedInvestor,
];

export const faqTTWList = [
  {
    id: 'meanToMakeAReservation',
    title: 'What does it mean when I make a reservation?',
    detail: (
      <Typography variant="p1" color="success">
        When you make a reservation, you’re simply indicating interest in an upcoming offering – not
        actually investing. This is non-binding, and no money changes hands. Later, when the
        offering launches, we’ll let you know, and you can decide whether you want to follow through
        with your investment at that point.
      </Typography>
    ),
  },
  {
    id: 'howToBeNotified',
    title: 'Once the offering launches, how will I be notified?',
    detail: (
      <Typography variant="p1" color="success">
        We’ll notify everyone who made a reservation – at which point, you can confirm whether you’d
        like to complete your investment or not.
      </Typography>
    ),
  },
  {
    id: 'willIBeCharged',
    title: 'Will I be charged?',
    detail: (
      <Typography variant="p1" color="success">
        No. At this stage, you’re simply indicating that you would be interested in an upcoming
        offering. After the offering launches, you’ll have a chance to confirm whether you’d like to
        complete your investment or not.
      </Typography>
    ),
  },
  {
    id: 'canICancel',
    title: 'Can I cancel my reservation?',
    detail: (
      <Typography variant="p1" color="success">
        Yes. At this stage, you’re simply indicating interest in an upcoming offering. This is
        non-binding, and you can choose to cancel at any time before making an actual investment.
      </Typography>
    ),
  },
];

export const faqList = [
  {
    id: 'faqHowMuchInvest',
    title: 'How much can I invest?',
    detail: (
      <Typography variant="p1" color="success">
        With Regulation A+, a non-accredited investor can only invest a maximum of 10% of their
        annual income or 10% of their net worth per year, whichever is greater. There are no
        restrictions for accredited investors.
        <br />
        <br />
        With Regulation Crowdfunding, non-accredited investors with an annual income or net worth
        less than $124,000 are limited to invest a maximum of 5% of the greater of those two
        amounts. For those with an annual income and net worth greater than $124,000, they are
        limited to investing 10% of the greater of the two amounts.
      </Typography>
    ),
  },
  {
    id: 'howToOpenIRA',
    title: 'How to open a Self-Directed IRA on StartEngine?',
    detail: (
      <Typography variant="p1" color="success">
        StartEngine makes it easy to invest using your retirement funds. You can open a
        self-directed IRA account through StartEngine. To get started, simply visit{' '}
        <a
          href="https://startengine.com/ira-account"
          style={{
            textDecoration: 'none',
            fontWeight: 700,
            color: colors.SEDark,
          }}
        >
          our IRA page
        </a>{' '}
        for more information and step-by-step instructions.
        <br />
        <br />
        Already have a self-directed IRA with another provider? You can still invest on StartEngine,
        but please note that the process will be manual and may take longer to complete.
      </Typography>
    ),
  },
  {
    id: 'faqReceiveShares',
    title: 'When will I receive my shares?',
    detail: (
      <Typography variant="p1" color="success">
        At the close of an offering, all investors whose funds have “cleared” by this time will be
        included in the disbursement. At this time, each investor will receive an email from
        StartEngine with their Countersigned Subscription Agreement, which will serve as their proof
        of purchase moving forward.
        <br />
        <br />
        Please keep in mind that a company can conduct a series of “closes” or withdrawals of funds
        throughout the duration of the campaign. If you are included in that withdrawal period, you
        will be emailed your countersigned subscription agreement and proof of purchase immediately
        following that withdrawal.
      </Typography>
    ),
  },
  {
    id: 'faqReturnOnInvestment',
    title: 'What will the return on my investment be?',
    detail: (
      <Typography variant="p1" color="success">
        StartEngine assists companies in raising capital, and once the offering is closed, we are no
        longer involved with whether the company chooses to list shares on a secondary market or
        what occurs thereafter. Therefore, StartEngine has no control or insight into your
        investment after the close of the live offering. In addition, we are not permitted to
        provide financial advice. You may want to contact a financial professional to discuss
        possible investment outcomes.
      </Typography>
    ),
  },
  {
    id: 'faqCancelInvestment',
    title: 'Can I cancel my investment?',
    detail: (
      <Typography variant="p1" color="success">
        For Regulation Crowdfunding, investors are able to cancel their investment at any point
        throughout the campaign up until 48 hours before the closing of the offering. Note: If the
        company does a rolling close, they will post an update to their current investors, giving
        them the opportunity to cancel during this timeframe. If you do not cancel within this 5-day
        timeframe, your funds will be invested in the company, and you will no longer be able to
        cancel the investment. If your funds show as ‘Invested’ on your account dashboard, your
        investment can no longer be canceled.
        <br />
        <br />
        For Regulation A+, StartEngine allows for a four-hour cancellation period. Once the
        four-hour window has passed, it is up to each company to set their own cancellation policy.
        You may find the company’s cancellation policy in the company’s offering circular.
        <br />
        <br />
        Once your investment is canceled, there is a 10-day clearing period (from the date your
        investment was submitted). After your funds have cleared the bank, you will receive your
        refund within 10 business days.
        <br />
        <br />
        Refunds that are made through ACH payments can take up to 10 business days to clear.
        Unfortunately, we are at the mercy of the bank, but we will do everything we can to get you
        your refund as soon as possible. However, every investment needs to go through the clearing
        process in order to be sent back to the account associated with the investment.
      </Typography>
    ),
  },
  {
    id: 'faqRegCrowdVsRegA',
    title: 'What is the difference between Regulation Crowdfunding and Regulation A+?',
    detail: (
      <Typography
        sx={{
          a: {
            color: 'secondary.main',
            textDecoration: 'none',
          },
        }}
      >
        Both Title III (Regulation Crowdfunding) and Title IV (Reg A+) help entrepreneurs crowdfund
        capital investments from unaccredited and accredited investors. The differences between
        these regulations are related to the investor limitations, the differing amounts of money
        companies are permitted to raise, and differing disclosure and filing requirements. To learn
        more about Regulation Crowdfunding,{' '}
        <a
          href={homeMenu.regulationCrowdfunding}
          target="_blank"
          style={{
            textDecoration: 'none',
          }}
          rel="noopener noreferrer"
        >
          learn about Regulation Crowdfunding
        </a>
        , and for Regulation A+,{' '}
        <a
          href={homeMenu.regulationA}
          target="_blank"
          style={{
            textDecoration: 'none',
          }}
          rel="noopener noreferrer"
        >
          learn about Regulation A+
        </a>
        .
      </Typography>
    ),
  },
];

const amountBasedPurchaseFaq = {
  id: 'faqAmountBasedPurchase',
  title: 'When I invest, what am I purchasing?',
  detail: (
    <Typography variant="p1" color="success">
      You are purchasing the securities described in the offering documents, such as a convertible
      note or SAFE. These securities represent an investment amount and may convert into equity in
      the future according to their terms.
    </Typography>
  ),
};

const amountBasedConfirmationFaq = {
  id: 'faqAmountBasedConfirmation',
  title: 'When will I receive confirmation of my investment?',
  detail: (
    <Typography variant="p1" color="success">
      At the close of an offering, all investors whose funds have “cleared” by this time will be
      included in the disbursement. At this time, each investor will receive an email from
      StartEngine with their Countersigned Subscription Agreement, which will serve as their proof
      of purchase moving forward.
      <br />
      <br />
      Please keep in mind that a company can conduct a series of “closes” or withdrawals of funds
      throughout the duration of the campaign. If you are included in that withdrawal period, you
      will be emailed your countersigned subscription agreement and proof of purchase immediately
      following that withdrawal.
    </Typography>
  ),
};

const amountBasedReturnFaq = {
  id: 'faqAmountBasedReturnOnInvestment',
  title: 'What will the return on my investment be?',
  detail: (
    <Typography variant="p1" color="success">
      StartEngine assists companies in raising capital, and once the offering is closed, we are no
      longer involved with whether the company chooses to list securities on a secondary market or
      what occurs thereafter. Therefore, StartEngine has no control or insight into your investment
      after the close of the live offering. In addition, we are not permitted to provide financial
      advice. You may want to contact a financial professional to discuss possible investment
      outcomes.
    </Typography>
  ),
};

export const amountBasedFaqList = faqList.flatMap((item) => {
  if (item.id === 'faqHowMuchInvest') return [item, amountBasedPurchaseFaq];
  if (item.id === 'faqReceiveShares') return [amountBasedConfirmationFaq];
  if (item.id === 'faqReturnOnInvestment') return [amountBasedReturnFaq];
  return [item];
});

export const amountBasedPrivateList = sePrivateList.flatMap((item) => {
  if (item.id === 'whenIInvest') return [amountBasedPurchaseFaq];
  if (item.id === 'whatsASeriesLLC' || item.id === 'howDoYouDetermine') return [];
  if (item.id === 'whenWillIReceiveMembershipInterest') return [amountBasedConfirmationFaq];
  if (item.id === 'whatWillTheReturnOnMyInvestmentBe') return [amountBasedReturnFaq];
  return [item];
});

const includeQualifiedPurchaserFaq = (items) => {
  const accreditedInvestorIndex = items.findIndex((faq) => faq.id === 'whatIsAnAccreditedInvestor');

  if (accreditedInvestorIndex === -1) {
    return items;
  }

  return [
    ...items.slice(0, accreditedInvestorIndex + 1),
    whatIsAQualifiedPurchaser,
    ...items.slice(accreditedInvestorIndex + 1),
  ];
};

export const getOfferingFAQList = ({
  isTTW = false,
  isRegD = false,
  isRegA = false,
  isAmountBased = false,
} = {}) => {
  if (isTTW) {
    if (isRegD || isRegA) {
      return faqTTWListAccred;
    }
    return faqTTWList;
  }

  if (isAmountBased) {
    return isRegD ? includeQualifiedPurchaserFaq(amountBasedPrivateList) : amountBasedFaqList;
  }

  if (isRegD) {
    return includeQualifiedPurchaserFaq(sePrivateList);
  }

  return faqList;
};
